import { lazy } from 'react';
import { Route } from 'react-router-dom';

const LoginPage = lazy(() => import('../auth/login/page'));
const RegisterPage = lazy(() => import('../auth/register/page'));
const VerifyEmailPage = lazy(() => import('../auth/verify-email/page'));
const ForgotPasswordPage = lazy(() => import('../auth/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../auth/reset-password/page'));

export const AuthRoutes = (
  <>
    <Route path="/auth/login" element={<LoginPage />} />
    <Route path="/auth/register" element={<RegisterPage />} />
    <Route path="/auth/verify-email" element={<VerifyEmailPage />} />
    <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
  </>
);
